import { useTranslation } from "react-i18next";
import { Dropdown, DropdownChangeParams } from "primereact/dropdown";
import { MeasurementMetadata, EventMetadata } from "../shared/interfaces/Data";

interface Props {
  value: MeasurementMetadata | EventMetadata | undefined;
  metadataList: (MeasurementMetadata | EventMetadata)[];
  onChange: (selectedCaptureId: number | undefined) => void;
}

export function HistoricMeasurementDateDropdown(props: Props) {
  const { t } = useTranslation();
  const { value, metadataList, onChange } = props;

  const dropdownOptions = metadataList.map((metadataItem) => ({
    captureId: metadataItem.captureId,
    time: t("common.formattedDateShort", {
      dateString: new Date(metadataItem.time).toISOString(),
    }),
  }));

  function handleChange(e: DropdownChangeParams) {
    onChange(e.value);
  }

  return (
    <Dropdown
      value={value?.captureId}
      optionValue="captureId"
      options={dropdownOptions}
      onChange={handleChange}
      optionLabel="time"
      placeholder={t("common.date")}
    />
  );
}
